import { tbColors, tbPalette } from 'styles/colors';

const getMuiIconButton = () => ({
  styleOverrides: {
    defaultProps: {
      disableRipple: true, // No more ripple, on the whole application 💣!
    },
    root: () => ({
      '&.MuiIconButton-root': {
        color: tbPalette.text.primary,
        backgroundColor: tbPalette.background.bright,
        width: 32,
        height: 32,
        borderRadius: 4,
      },
      '& svg': {
        width: 20,
        height: 20,
        color: tbColors.all.ash[900],
      },
      padding: 6,
      '&:hover': {
        backgroundColor: tbPalette.interactive.surface.hover,
      },
      '&:active': {
        backgroundColor: tbPalette.interactive.surface.active,
      },
    }),
    sizeSmall: {
      '& svg': {
        width: 14,
        height: 14,
      },
      // Keep the compact icon-button hit area aligned with the previous design tokens.
      padding: 3,
    },
  },
});
export default getMuiIconButton;
